import { Component, OnInit } from '@angular/core';
import { SALESFORCE_CONNECT_EDIT_FORM_CONFIG } from '../../utils/salesforce-connect-edit-form-config';
import { salesforceContent } from '../../utils/salesforce-content';
import { SalesforceLoginAndGetObjectsFailure, SalesforceLoginAndGetSelectedObjects } from '../../state/salesforce.actions';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { errorAlertConfig } from '../../utils/file-list.configs';
import { Subscription } from 'rxjs';
import { RappiderFormWithGuidanceModule } from 'libs/components/src/lib/components/form-with-guidance/form-with-guidance.module';

@Component({
  selector: 'rappider-salesforce-connect',
  templateUrl: './salesforce-connect.component.html',
  styleUrls: ['./salesforce-connect.component.scss'],
  standalone: true,
  imports: [CommonModule,RappiderFormWithGuidanceModule]
})
export class RappiderSalesforceConnectComponent implements OnInit {

  subscriptions: Subscription[] = [];
  editFormConfig = SALESFORCE_CONNECT_EDIT_FORM_CONFIG;
  content = salesforceContent;
  errorAlertConfig = errorAlertConfig;
  submitButtonLoading = false;

  constructor(
    private store: Store<any>,
  ) { }


  ngOnDestroy() {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.store.dispatch(SalesforceLoginAndGetObjectsFailure({ payload: { error: null, key: '', timestamp: 0 } }))
  }

  ngOnInit() {
    this.subscriptions = [
      this.subscribeToSalesforceModelsLoading(),
      this.subscribeToSalesforceError()
    ];
  }

  onFormSubmit(formData) {
    this.store.dispatch(SalesforceLoginAndGetSelectedObjects({ payload: { username: formData.username, password: formData.password, token: formData.token } }));
  }

  subscribeToSalesforceModelsLoading() {
    return this.store.select(state => state.salesforce?.loading).subscribe((loading) => {
      this.submitButtonLoading = loading;
    });
  }

  subscribeToSalesforceError() {
    return this.store.select(state => state.salesforce?.error).subscribe((error) => {
      if (error?.error?.error) {
        this.errorAlertConfig.description.text = error?.error?.error?.message || error?.error?.error;
      } else {
        this.errorAlertConfig.description.text = null;
      }
    });
  }

}
